import { render, staticRenderFns } from "./TaskDetailCommentAddForm.vue?vue&type=template&id=78736c26&lang=pug&"
import script from "./TaskDetailCommentAddForm.vue?vue&type=script&lang=js&"
export * from "./TaskDetailCommentAddForm.vue?vue&type=script&lang=js&"
import style0 from "./TaskDetailCommentAddForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports